var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.marker === "10.1"
    ? _c("div", [
        _c("div", { staticClass: "tonguereport" }, [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "leftsty",
              on: {
                click: function($event) {
                  return _vm.checkfacestate(
                    _vm.facestate === 0 ? 3 : _vm.facestate - 1
                  )
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.facestate === 0
                      ? "苔质"
                      : _vm.facestate === 1
                      ? "舌色"
                      : _vm.facestate === 2
                      ? "舌形"
                      : _vm.facestate === 3
                      ? "苔色"
                      : ""
                  ) +
                  " "
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "leftsty2",
              on: {
                click: function($event) {
                  return _vm.checkfacestate(
                    _vm.facestate === 0
                      ? 2
                      : _vm.facestate === 1
                      ? 3
                      : _vm.facestate - 2
                  )
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.facestate === 0
                      ? "苔色"
                      : _vm.facestate === 1
                      ? "苔质"
                      : _vm.facestate === 2
                      ? "舌色"
                      : _vm.facestate === 3
                      ? "舌形"
                      : ""
                  ) +
                  " "
              )
            ]
          ),
          _c("div", { staticClass: "centersty" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.facestate === 0
                    ? "舌色"
                    : _vm.facestate === 1
                    ? "舌形"
                    : _vm.facestate === 2
                    ? "苔色"
                    : _vm.facestate === 3
                    ? "苔质"
                    : ""
                ) +
                " "
            )
          ]),
          _c(
            "div",
            {
              staticClass: "rightsty",
              on: {
                click: function($event) {
                  return _vm.checkfacestate(
                    _vm.facestate === 3 ? 0 : _vm.facestate + 1
                  )
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.facestate === 0
                      ? "舌形"
                      : _vm.facestate === 1
                      ? "苔色"
                      : _vm.facestate === 2
                      ? "苔质"
                      : _vm.facestate === 3
                      ? "舌色"
                      : ""
                  ) +
                  " "
              )
            ]
          ),
          _c("div", { staticClass: "resultL" }, [
            _vm._m(1),
            _c("div", { staticClass: "result-content" }, [
              _c("div", { staticClass: "imgstyL" }, [
                _vm.facestate === 0
                  ? _c(
                      "div",
                      {
                        staticClass: "tongue-ss",
                        staticStyle: { width: "100%", border: "none" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "100%",
                              width: "96%",
                              "margin-left": "2%"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "39%",
                                  "margin-top": "10px"
                                }
                              },
                              [
                                _c("div", { staticClass: "circular1" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "font-size": "34px",
                                        "line-height": "112px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tonguereport.nature_L))]
                                  )
                                ]),
                                _c("div", { staticClass: "circular2" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "font-size": "34px",
                                        "line-height": "112px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tonguereport.nature_a))]
                                  )
                                ]),
                                _c("div", { staticClass: "circular3" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "font-size": "34px",
                                        "line-height": "112px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tonguereport.nature_b))]
                                  )
                                ])
                              ]
                            ),
                            _vm._m(2),
                            _vm._m(3),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "20px",
                                  "text-align": "left"
                                }
                              },
                              [
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "结果：" +
                                      _vm._s(
                                        _vm.tonguereport
                                          .tongue_nature_color_info.name
                                      )
                                  )
                                ]),
                                _c("br"),
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "提示：" +
                                      _vm._s(
                                        _vm.tonguereport
                                          .tongue_nature_color_info
                                          .content[0] === "正常"
                                          ? ""
                                          : "常见于"
                                      ) +
                                      _vm._s(
                                        _vm.tonguereport
                                          .tongue_nature_color_info.content[0]
                                      )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.facestate === 1
                  ? _c(
                      "div",
                      {
                        staticClass: "tongue-sx",
                        staticStyle: { width: "100%", border: "none" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "100%",
                              width: "96%",
                              "margin-left": "2%",
                              "margin-top": "25px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "0",
                                  "text-align": "center",
                                  "font-size": "36px"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.tonguereport.tongueFatThin === 0
                                        ? _vm.tonguereport.tongueCrack === 0
                                          ? "正常"
                                          : "有裂痕"
                                        : _vm.tonguereport.tongueCrack === 0
                                        ? "舌胖"
                                        : "舌胖、有裂痕"
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "0",
                                  "text-align": "left"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "span-tip",
                                    staticStyle: { "vertical-align": "top" }
                                  },
                                  [_vm._v("结果：")]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "span-tip",
                                    staticStyle: {
                                      "margin-left": "0",
                                      width: "600px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tonguereport.tongue_fat_thin_info
                                          .name
                                      ) +
                                        "，" +
                                        _vm._s(
                                          _vm.tonguereport.tongue_crack_info
                                            .name
                                        )
                                    )
                                  ]
                                ),
                                _c("br"),
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "提示：" +
                                      _vm._s(
                                        _vm.tonguereport.tongue_fat_thin_info
                                          .content[0] === "正常"
                                          ? ""
                                          : "常见于"
                                      ) +
                                      _vm._s(
                                        _vm.tonguereport.tongueFatThin === 1
                                          ? _vm.tonguereport
                                              .tongue_fat_thin_info.content[0]
                                          : ""
                                      ) +
                                      _vm._s(
                                        _vm.tonguereport.tongue_crack_info
                                          .content[0]
                                      )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.facestate === 2
                  ? _c(
                      "div",
                      {
                        staticClass: "tongue-ts",
                        staticStyle: { width: "100%", border: "none" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "100%",
                              width: "96%",
                              "margin-left": "2%"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "39%",
                                  "margin-top": "10px"
                                }
                              },
                              [
                                _c("div", { staticClass: "circular1" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "font-size": "34px",
                                        "line-height": "112px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tonguereport.coat_L))]
                                  )
                                ]),
                                _c("div", { staticClass: "circular2" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "font-size": "34px",
                                        "line-height": "112px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tonguereport.coat_a))]
                                  )
                                ]),
                                _c("div", { staticClass: "circular3" }, [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "font-size": "34px",
                                        "line-height": "112px"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.tonguereport.coat_b))]
                                  )
                                ])
                              ]
                            ),
                            _vm._m(4),
                            _vm._m(5),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "18px",
                                  "text-align": "left"
                                }
                              },
                              [
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "结果：" +
                                      _vm._s(
                                        _vm.tonguereport.tongue_coat_color_info
                                          .name
                                      )
                                  )
                                ]),
                                _c("br"),
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "提示：" +
                                      _vm._s(
                                        _vm.tonguereport.tongue_coat_color_info
                                          .content[0] === "正常"
                                          ? ""
                                          : "常见于"
                                      ) +
                                      _vm._s(
                                        _vm.tonguereport.tongue_coat_color_info
                                          .content[0]
                                      )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.facestate === 3
                  ? _c(
                      "div",
                      {
                        staticClass: "tongue-tz",
                        staticStyle: { width: "100%", border: "none" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              height: "100%",
                              width: "96%",
                              "margin-left": "2%",
                              "margin-top": "25px"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "15px",
                                  "text-align": "center",
                                  "font-size": "36px"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.tonguereport
                                        .tongue_coat_thickness_info.symptom
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "19px",
                                  "text-align": "left"
                                }
                              },
                              [
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "结果：" +
                                      _vm._s(
                                        _vm.tonguereport
                                          .tongue_coat_thickness_info.name
                                      )
                                  )
                                ]),
                                _c("br"),
                                _c("span", { staticClass: "span-tip" }, [
                                  _vm._v(
                                    "提示：" +
                                      _vm._s(
                                        _vm.tonguereport
                                          .tongue_coat_thickness_info
                                          .content[0] === "正常"
                                          ? ""
                                          : "常见于"
                                      ) +
                                      _vm._s(
                                        _vm.tonguereport
                                          .tongue_coat_thickness_info.content[0]
                                      )
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _c("div", {
              staticClass: "back",
              staticStyle: { "margin-top": "38px" },
              on: { click: _vm.returnto }
            })
          ]),
          _c(
            "div",
            { staticClass: "tongue-lab", on: { click: _vm.ReturnToLab } },
            [
              _c("i", [_vm._v("Lab颜色空间及相关数值意义")]),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#006A95",
                    float: "right",
                    "margin-right": "15px"
                  }
                },
                [_vm._v("点击了解一下")]
              )
            ]
          )
        ])
      ])
    : _c("div", [
        _c(
          "div",
          {
            staticClass: "tonguereport",
            style:
              _vm.access === "web" ? { height: "1920px" } : { height: "100%" }
          },
          [
            _vm.tonguereport
              ? _c("TongueDetail", {
                  attrs: { isOnlyTongue: !_vm.isFromReportHome }
                })
              : _vm._e()
          ],
          1
        )
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "face-top", staticStyle: { "margin-top": "80px" } },
      [
        _c("span", { staticClass: "title" }, [_vm._v("舌诊结果")]),
        _c("span", {
          staticClass: "title-border",
          staticStyle: { top: "154px" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "imgsty",
        staticStyle: { "border-bottom": "none", height: "352px" }
      },
      [
        _c("img", {
          staticStyle: { height: "314px", "margin-top": "25px" },
          attrs: {
            src: require("../../assets/img/menopauseovary/sxjg.gif"),
            alt: "面诊图片"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "6px" } }, [
      _c("span", { staticClass: "spansty" }, [_vm._v("L值")]),
      _c("span", { staticClass: "spansty" }, [_vm._v("A值")]),
      _c("span", { staticClass: "spansty" }, [_vm._v("B值")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "20px" } }, [
      _c("span", { staticClass: "spaninfo" }, [
        _vm._v("L值越大舌色越鲜亮，a值越大越淡，b值越大越紫暗")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "9px" } }, [
      _c("span", { staticClass: "spansty" }, [_vm._v("L值")]),
      _c("span", { staticClass: "spansty" }, [_vm._v("A值")]),
      _c("span", { staticClass: "spansty" }, [_vm._v("B值")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "20px" } }, [
      _c("span", { staticClass: "spaninfo" }, [
        _vm._v("L值越小苔色越暗，a值越大越白，b值越大越黄")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }